<template>
  <div class="sidebar">
    <a href="/">
      <img src="@/assets/images/logo/logo.png" class="d-block mx-auto mt-5" style="max-width: 200px;  width:100%" alt="Northwest logo">
    </a>
    <ul class="pl-0 mt-5 text-center" style="list-style: none;">
      <li class="nav-item">
        <div class="form-group p-4">
          <select class="form-control btn btn-outline-light" id="exampleFormControlSelect1">
            <option disabled selected>Selecciona tu ciudad</option>
            <option>Culiacán</option>
            <option>Los Mochis</option>
          </select>
        </div>
      </li>
      <li class="mt-4">
        <h4><a class="font-weight-bold text-light" href="/">Inicio</a></h4>
      </li>
      <li class="mt-4">
        <h4><a class="font-weight-bold text-light" href="/consultoria">Autos Nuevos s</a></h4>
        <div class="sublist_options">
          <div><a href="/autosnuevoschevrolet"><img src="@/assets/images/marcas/chevrolet.png" style="width: 50px;" alt="Logo de chevrolet"></a></div>
          <div><a href="/autosnuevoscadillac"><img src="@/assets/images/marcas/cadillac.png" style="width: 50px;" alt="Logo de chevrolet"></a></div>
        </div>
      </li>
      <li class="mt-4">
        <h4><a class="font-weight-bold text-light"  href="/autosseminuevoschevrolet"  >Seminuevos</a></h4>
        <!-- <div class="sublist_options">
          <div><a href="/autosseminuevoschevrolet"><img src="@/assets/images/marcas/chevrolet.png" style="width: 50px;" alt="Logo de chevrolet"></a></div>
          <div><a href="/autosseminuevoscadillac"><img src="@/assets/images/marcas/cadillac.png" style="width: 50px;" alt="Logo de chevrolet"></a></div>
        </div> -->
      </li>
      <li class="mt-4">
        <h4><a class="font-weight-bold text-light" href="/promotions">Promociones</a></h4>
      </li>
      <li class="mt-4">
        <h4><a class="font-weight-bold text-light" href="/consultoria">Servicios</a></h4>
        <div class="sublist_options2 servicios">
          <div>
            <p>Agenda tu cita</p>
          </div>
          <div>
            <p>Postventa</p>
          </div>
          <div>
            <p>Financiamiento</p>
          </div>
        </div>
      </li>
      <li class="mt-4">
        <h4><a class="font-weight-bold text-light" href="/contacto">Contacto-->>></a></h4>
      </li>
    </ul>
    <button class="btn btn-light text-dark togglebutton mt-3 position-fixed d-block d-md-none d-lg-none" style="top: 20px; right: 20px;"><i class="fas fa-bars"></i></button>
  </div>
</template>
<script>
export default {
  name: 'Sidebar'
}
</script>

<style scoped>

</style>
